// table-expand.vue
<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <Row class="expand-row">
      <Col span="8">
      <span class="expand-key">name</span>
      <span class="expand-value">{{ row.title }}</span>
      </Col>
      <Col span="8">
      <span class="expand-key">Mobile: </span>
      <span class="expand-value">{{ row.phone }}</span>
      </Col>
      <Col span="8">
      <span class="expand-key">Note: </span>
      <span class="expand-value">{{ row.note }}</span>
      </Col>
    </Row>
    <Row>
      <Col span="8">
      <span class="expand-key">时间: </span>
      <span class="expand-value">{{ row.time }}</span>
      </Col>
      <Col span="8">
      <span class="expand-key">Favorite movie: </span>
      <span class="expand-value">{{ row.movie }}</span>
      </Col>
      <Col span="8">
      <span class="expand-key">Favorite music: </span>
      <span class="expand-value">{{ row.music }}</span>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  props: {
    row: Object
  }
};
</script>
